export default __webpack_public_path__ + "static/media/remove.3c662b75.png";